export const allowedTemplateExtensions = ['zip'];
export const allowedAudioExtensions = ['m4a', 'mp3', 'wav'];
export const allowedImageExtensions = ['png', 'jpg', 'jpeg'];
export const allowedVideoExtensions = ['mp4'];

const isValidExtension = (allowedFileExtensions: string[], value: string) =>
  allowedFileExtensions.some(extension => value.endsWith(`.${extension}`));

const validateFile = (allowedExtensions: string[], value: File | string) => {
  const fileName = value instanceof File ? value.name : value;

  if (fileName && !isValidExtension(allowedExtensions, fileName)) {
    return `Only .${allowedExtensions.join(', .')} files are accepted`;
  }

  return undefined;
};

export const validateTemplateFile = (value: File | string) => validateFile(allowedTemplateExtensions, value);

export const validateAudioFile = (value: File | string) => validateFile(allowedAudioExtensions, value);

export const validateImageFile = (value: File | string) => validateFile(allowedImageExtensions, value);

export const validateVideoFile = (value: File | string) => validateFile(allowedVideoExtensions, value);

export const validateVideoOrImageFile = (value: File | string) =>
  validateFile(allowedImageExtensions.concat(allowedVideoExtensions), value);
